<div class="login-wrapper">

  <img class="identity-icon" src="./assets/identity/logo.png" />
  <div class="col-lg-4 col-xl-3 mx-auto" style="text-align: -webkit-center;">
    <!-- <div class="card-img-left d-none d-md-flex" style="overflow:hidden">
          <img src="./assets/img/login-background.jpg">
        </div> -->

    <div style="text-align: end;" class="switch-lang">
      <div class="row justify-content-between mx-1">
        <div class="d-flex justify-content-sm-start">
          <a href="./assets/download/TruckScaleSetup.msi" class="font-small"><i class="fas fa-download"></i></a>
          <a (click)="loginWithToken()" class="text-primary font-small">Token</a>
        </div>
        <button class="btn p-0" (click)="switchLang()">
          <img src="https://hatscripts.github.io/circle-flags/flags/us.svg" width="28" *ngIf="translate.currentLang =='ar'">
          <img src="https://hatscripts.github.io/circle-flags/flags/eg.svg" width="28" *ngIf="translate.currentLang =='en'">
        </button>
      </div>

    </div>

    <div class="user-icon d-flex">
      <img src="./assets/img/user.png">
    </div>

    <div class="card-body py-4 px-5">
      <!-- <div class="d-flex justify-content-center">
            <img src="./assets/identity/logo.png" style="width: 50%">
          </div> -->
      <br>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <!-- <i class="fas rounded-0 fa-user input-group-text"></i> -->
            <i class="input-group-text px-2 p-1 rounded-0">
              <mat-icon style="font-size:20px" class="align-self-end">person</mat-icon>
            </i>

          </div>
          <input type="text" class="rounded-0 form-control" formControlName="username" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" placeholder="{{'username' | translate}}">
          <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
            <div *ngIf="f.username.errors.required">{{'username-required'|translate}}</div>
          </div>
        </div>

        <div class="input-group mb-3">
          <i class="input-group-text px-2 p-1 rounded-0">
            <mat-icon style="font-size:20px" class="align-self-end">lock</mat-icon>
          </i>

          <input type="password" formControlName="password" class="rounded-0 form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" placeholder="{{'password'|translate}}">
          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required">{{'password-required'|translate}}</div>
          </div>
        </div>

        <div class="checkbox d-flex justify-content-between mb-2 mt-4 px-1 pass-actions">
          <label class="text-color-theme" style="font-size: 12px;">
            <input class="mx-1" [(ngModel)]="remeberMe" [ngModelOptions]="{standalone: true}" type="checkbox">
            {{"remember-me"|translate}}
          </label>
          <label style="font-size: 12px;">
            <a class="text-color-theme" [routerLink]="['/VerifyEmail']">{{"forgot-password"|translate}}</a>
          </label>
        </div>
        <br>

        <button [disabled]="loading" class="btn btn-block rounded-0 p-2 bg-sec" style="font-size: 13px;" type="submit" expand="block">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          {{"login"|translate}}
        </button>

        <div class="d-flex flex-row justify-content-between mt-3">
          <div class="d-flex flex-column align-items-start" style="line-height: 1.4;">
            <small class="color-sec">{{"follow-us"|translate}}</small>
            <div class="social-icons" class="flex-row">
              <a target="_black" [href]="companySettings?.OtherSettings?.InstagramLink">
                <i class="fa-brands mx-1 fa-instagram text-color-theme">
                </i>
              </a>
              <a target="_black" [href]="companySettings?.OtherSettings?.FacebookLink">
                <i class="fa-brands mx-1 fa-facebook text-color-theme"></i>
              </a>
              <a target="_black" [href]="companySettings?.OtherSettings?.LinkedInLink">
                <i class="fa-brands mx-1 fa-linkedin text-color-theme"></i>
              </a>
            </div>
          </div>
          <div style="line-height: 1.3;" class="d-flex flex-column text-color-theme justify-content-center align-items-center">
            <small style="margin: 0px 3px !important; font-weight: 600; font-size: 14px;">{{supportNumber}}</small>
            <small style="font-size: 10px;">{{"call-us"|translate}}</small>
          </div>

        </div>
      </form>
      <br>

    </div>
  </div>
  <div class="version">{{currentVersion}}</div>
</div>
